<template>
    <v-container fluid>
        <template v-if="this.reseller">
            <reseller-form
                :model="reseller"
                :newReseller="false"
                @saved="saved"
                type="edit"
                :titlePrefix="$t('partner.edit.texts.title-prefix')"
            ></reseller-form>

            <hr />

            <v-row>
                <v-col class="pr-0 pl-0">
                    <addresses-index :reseller_id="reseller.id" />
                </v-col>
            </v-row>
        </template>

        <template v-else>
            <v-row>
                <v-col class="text-center">
                    <v-progress-circular
                        :size="50"
                        color="primary"
                        indeterminate
                    ></v-progress-circular>
                </v-col>
            </v-row>
        </template>
    </v-container>
</template>

<script>
import ResellerModel from '@/models/Reseller'
import ResellerForm from './Form'
import AddressesIndex from '../addresses/Index.vue'

export default {
    props: ['id'],

    data: () => {
        return {
            reseller: null,
        }
    },

    components: {
        'reseller-form': ResellerForm,
        AddressesIndex,
    },

    methods: {
        async getReseller() {
            let reseller = await this.model.find(this.id)

            this.reseller = reseller
        },

        saved() {
            this.$router.go(-1)
        },
    },

    computed: {
        model() {
            return new ResellerModel()
        },
    },

    created() {
        this.getReseller()
    },
}
</script>
